import React, { StrictMode } from "react";
import App from "./App";
import { createRoot } from "react-dom/client";
import "./styles/legacy.scoped.css";
import "./styles/refresh.scoped.css";
import { applyCachedUi } from "./theme/ui";

// Pick the UI generation before React mounts (see src/theme/ui.js).
applyCachedUi();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
